import { Outlet, useLocation, useNavigate } from 'react-router-dom'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { AccountsPayableUpsellModal } from 'modules/finance/components/AccountsPayableUpsellModal'
import CollectionsBootstrap from 'modules/procurement/lib/CollectionsBootstrap'

const RootPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const location = useLocation()

  useUnsafeEffect(() => {
    if (location.pathname === navigation.procurement.fullPath()) {
      navigate(navigation.procurement.purchaseRequests.fullPath())
    }
  }, [navigate, location.pathname, navigation])

  return (
    <CollectionsBootstrap>
      <AccountsPayableUpsellModal source="ap_procurement_upsellcard"></AccountsPayableUpsellModal>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
